import styled from 'styled-components'

import { RequiredTextField } from '../../../form/RequiredFields'
import { suggestionItemHeightInPx } from '../AddressSuggestedPlacesItem'

export const Container = styled.div`
  position: relative;
  overflow: hidden;
`

const filledInputPaddingBottomPx = 10

export const AddressStreetInputField = styled(RequiredTextField)<{
  $predictionsCount: number
}>`
  input {
    ${({ $predictionsCount }) =>
      $predictionsCount > 0
        ? `padding-bottom: ${
            $predictionsCount * suggestionItemHeightInPx + filledInputPaddingBottomPx
          }px`
        : ''}
  }
`
